<template>
  <VLayout column>
    <Header/>
    <UniqueLinkComponent/>
    <Footer/>
  </VLayout>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import UniqueLinkComponent from '@/components/UniqueLinkComponent.vue';

export default {
  name: 'UserLanding',
  components: {
    Header,
    Footer,
    UniqueLinkComponent,
  },
  data: () => ({
    link: null,
    mainLink: null,
    errorFetchingData: false,
    textError: 'No se encontró información del link de pago.',
  }),
};
</script>
